export default "__VITE_ASSET__D_Bz3cyQ__"